/**
 * Company: AltSolution
 */

"use strict";
jQuery.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// GA
import GoogleDataLayer from "./statistic/GoogleDataLayerAction";
window.GA = new GoogleDataLayer();

// GA Catalog
if($('[data-st-category-wrap]').length) {
    window.GA.pushCategoryList();
}

// GA Open product
if($('[data-st-item-single]').length) {
    let $this = $('[data-st-item-single]');
    let productData = {
        name: $this.attr('data-st-name'),
        id: $this.attr('data-st-id'),
        price: $this.attr('data-st-price'),
        brand: $this.attr('data-st-brand'),
        category: $this.attr('data-st-category'),
    };
    window.GA.pushOpenSingleProduct(productData);
}

// GA Thanx page
if($('[data-st-thanx]').length) {
    let $this = $('[data-st-thanx]');
    let orderData = {
        id: $this.attr('data-st-id'),
        price: $this.attr('data-st-price'),
        shipping: $this.attr('data-st-shipping'),
        coupon: $this.attr('data-st-promo')
    };
    window.GA.pushOrderData(orderData);
}


//Catalog & others
import FilterProducts from "./filter/FilterProductsClass";
import CartActions from "./product/CartActionsClass";
import FavoriteActions from "./product/FavoriteActionsClass";
import AddressActions from "./profile/AddressActionClass";
import UsersData from "./profile/UsersDataClass";
import OrdersProfileData from "./profile/OrdersDataClass";
import FavoritesProfileData from "./profile/FavoritesClass";
import StopScroll from "./stopScrollClass";

let globalStopScroll = null;
$(document).ready(function () {
    if($('.wysiwyg-base-style pre').length){
        $(".wysiwyg-base-style pre").wrap('<div class="base-style-mCustomScrollbar"></div>');
        $(".base-style-mCustomScrollbar").mCustomScrollbar({
            axis:"x",
            mouseWheel:{ preventDefault: false },
        });
    }

    new CartActions().getCart();
    new FavoriteActions();

    if($('#row_first').length){
        $('input[name="name"]').focus()
    }

    //Catalog
    if ('categoryObj' in window || 'searchObj' in window) {
        const argFilter = {
            container: '#xhr-catalog-wrap',
            filterUrl: filterRoute.url,
            fastFiltersCl: '.sort-categories li[data-f], .sort-direction li[data-direct]',
            filtersCl: '.checkbox-filter :checkbox',
            categoryFiltersCl: '#special_category input',
            brandsFiltersCl: '#special_brand input',
            params: filterParams
        };
        new FilterProducts(argFilter);
    }

    //Blog
    if ('blogObj' in window) {
        const argFilter = {
            container: '#xhr-blog-wrap',
            filterUrl: filterRoute.url,
            params: filterParams,
        };
        new FilterProducts(argFilter);
    }

    //Profile
    if('profileObject' in window) {
        //Listen tabs & initial other tabs
        let profileData = null,
            profileAddress = null,
            profileFavorites = null,
            profileOrders = null;

        //Get hash & load page
        if(!window.location.hash) {
            UsersData.initial();
        } else {
            let hash = window.location.hash.slice(1);
            setTimeout(function () {
                $('.tab_controls a[data-id="'+ hash +'"]').trigger('click');
            }, 500);
        }

        $('.account_wrap').on('click', '.tab_controls a, .tab_header', function () {
            history.pushState(null,null,$(this).attr('href'));

            if(!profileData && $(this).attr('data-id') === 'contact-info') {
                profileData = UsersData.initial();
            }
            if(!profileAddress && $(this).attr('data-id') === 'address-book') {
                profileAddress = new AddressActions();
            }
            if(!profileFavorites && $(this).attr('data-id') === 'favorites-list') {
                profileFavorites = new FavoritesProfileData();
            }
            if(!profileOrders && $(this).attr('data-id') === 'orders-history') {
                profileOrders = new OrdersProfileData();
            }
        });
    }

    function priceFormat(price) {
        return price.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    }

    function disable_scroll_mobile(){
        window.addEventListener('touchmove', wheel, { passive: false });
    }
    function enable_scroll_mobile(){
        window.removeEventListener('touchmove', wheel, { passive: false });
    }
    var keys = [32,33,34,35,36,37,38,39,40];
    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }
    function keydown(e) {
        for (var i = keys.length; i--;) {
            if (e.keyCode === keys[i] && !$('input, textarea').is(":focus")) {
                preventDefault(e);
                return;
            }
        }
    }
    function wheel(e) {
        preventDefault(e);
    }
    function disable_scroll() {
        console.log('custom dis')
        if (window.addEventListener) {
            window.addEventListener('DOMMouseScroll', wheel);
        }
        window.addEventListener('mousewheel', wheel, { passive: false });
        document.onkeydown = keydown;
        disable_scroll_mobile();
    }
    function enable_scroll() {
        if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', wheel);
        }
        window.removeEventListener('mousewheel', wheel, { passive: true });
        enable_scroll_mobile();
    }

    /*** iOS Body Scroll Lock with open menu/other modal blocks ***/

    var $docEl = $('body'),
    scrollTop;
    var overlayClose = function() {
        $.unlockBody();
    }
    var overlayOpen = function() {
        $.lockBody();
    }
    $.lockBody = function() {
        if(window.pageYOffset) {
            scrollTop = window.pageYOffset;
        }
        $docEl.css({
            height: "100%",
            overflow: "hidden"
        });
        $('html').css({
            height: "100%",
            overflow: "hidden"
        });
    }
    $.unlockBody = function() {
        $docEl.css({
            height: "",
            overflow: ""
        });
        $('html').css({
            height: "",
            overflow: ""
        });
        window.scrollTo(0, scrollTop);
        window.setTimeout(function () {
            scrollTop = null;
        }, 0);
    }
    $('.overlay_page').on('click', function() {
        if($('#settingsCookie').css('display') == 'block'){
            return false
        }
        $('.menu').removeClass('show');
        $('.sort-block').removeClass('show');
        $('.filter-block').removeClass('show');
        $('.filter-blog').removeClass('show');
        // $('.overlay_page').fadeOut(200);
        $('.overlay_page').fadeOut(200).removeClass('showed');
        $('.search_block').fadeOut(300);
        $('#search').val('');
        $('.filter_block').animate({left: '-100%'}, 200);
        if(window.innerWidth < 1092){
            overlayClose();
            // enable_scroll();
        } else {
            // enable_scroll();
            // $('body').css({'overflow': 'auto', 'height': 'auto'});
            // $('html').css({'overflow': 'auto'});
        }

        $('#cartModal').removeClass('hide-for-next-popup');
        $('#available-warn').removeClass('close-only-this show-cart-then');

        enable_scroll();
    });


    /* Connects custom scrollbar */
    $(".mCustomScrollbar:not(.mCustomScrollbar-stop)").mCustomScrollbar({
        axis:"y",
    });

    $(".mCustomScrollbar-stop").mCustomScrollbar({
        axis:"y",
        mouseWheel:{ preventDefault: true },
    });

    /**
     * Tabs
     */
    let $tabArea = $('.tab_area');
    if($tabArea.length) {
        $tabArea.on('click', '.tab_controls a:not(.active):not(.no-tab)', function (e) {
            e.preventDefault();
            let id = $(this).attr('data-id');
            if(id) {
                $(this).parent().find('.active').removeClass('active');
                $(this).addClass('active');

                let $parent = $(this).closest('.tab_area');
                $parent.find('.tab_content:not(#'+id+')').fadeOut(200, function () {
                    $parent.find('#'+id).fadeIn(200);
                    if($('.checkout_tabs').length) {
                        $parent.find('#'+id).find('input')[0].focus();
                    }
                });

                if($('.account-page').length) {
                    $('.tab_header.open').removeClass('open');
                    $parent.find('#'+id).prev('.tab_header').addClass('open');
                }
            } else {
                console.warn('Please set "data-id"!')
            }

            // if($(this).attr('data-id') == 'favorites-list') {
            //     if(!$('#favorites-list .favorites-list li').length) {
            //         $('#favorites-list .left-list').hide();
            //         $('#favorites-list .text-empty').show();
            //     }
            // }
        });
    }


    /**
     * Phone mask
     */

    $('.phone_inputmask').inputmask('+38 (999) 999-99-99', {
        "oncomplete": function(){
            $(this).addClass('completed');
        },
        "onincomplete": function () {
            $(this).removeClass('completed');
        },
    });


    // $('input:not([type="email"])').on('focus', function() {
    //     var that = this;
    //     setTimeout(function(){ that.selectionStart = that.selectionEnd = 10000; }, 0);
    // });
    // $('input[type="email"]').on('focus', function() {
    //     var input = this;
    //     setTimeout(function () {
    //         $(input).attr('type', 'text');
    //         input.setSelectionRange($(input).val().length, $(input).val().length);
    //         $(input).attr('type', 'email');
    //     }, 100);
    // });

    /**
     * Form validate
     */
    $.validator.methods.email = function( value, element ) {
        return this.optional( element ) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test( value );
    };
    $.validator.methods.tel = function( value, element ) {
        return this.optional( element ) || /^((\+38)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test( value );
    };

    /**
     * Open|Close popups
     */
    let $openPanel = $('.open_panel');
    $openPanel.on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');
        if(id) {
            $('#' + id).addClass('open');
            $('.overlay_page').fadeIn(200);
            if(window.innerWidth < 1092){
                overlayOpen();
            } else {
                disable_scroll();
                // $('body').css({'overflow': 'hidden', 'height': '100%'});
                // $('html').css({'overflow': 'hidden'});
            }
        } else {
            console.warn('Set Id to popup!');
        }
    });

    /**
     * Fix for Edge
     */
    if (/Edge|MSIE|Trident/.test(navigator.userAgent)) {
        $('picture').each(function () {
            $(this).after(($(this).find('img')));
            $(this).remove();
        });
    }

    if(window.innerWidth < 992){
        setTimeout(function() {
            $('.cart-list').find('input').each(function() {
                calcService(this);
                calculateCart();
                calculateCartTotal();
            });
        }, 100);
        calculateCartTotal();
    }



    /**
     * Hover duration
     */
    function hoverDelivery(el_1, el_2) {
        var $classFirst = el_1,
            $classSecond = el_2,
            interval = 100,
            timer = null,
            timerDelayHover = null;

        $classFirst.hover(function () {
            if($(this).closest('.hover_delivery').hasClass('empty')) return false;

            clearTimeout(timer);
            var $this = $(this);

            //Need for set delay before show these blocks
            timerDelayHover = setTimeout(function () {
                $this.addClass('open');
                $this.parent().find($classSecond).css({
                    'visibility': 'visible',
                    'opacity': '1'
                });
                //When we need add class to top parent
                if($this.attr('data-parent')) {
                    $this.closest('.' + $this.attr('data-parent')).addClass('open');
                }
            }, 200);
        }, function () {
            clearTimeout(timerDelayHover);
            var $this = $(this);
            timer = setTimeout(function () {
                closeBlur($this, $this.parent().find($classSecond));
            }, interval)
        });

        $classSecond.hover(function () {
            clearTimeout(timer);
        }, function () {
            var $this = $(this);
            timer = setTimeout(function () {
                closeBlur($this.parent().find($classFirst), $this);
            }, interval)
        });

        function closeBlur($class_1, $class_2) {
            $class_1.removeClass('open');
            $class_2.css({
                'visibility': 'hidden',
                'opacity': '0'
            });
            //When we need add class to top parent
            if($class_1.attr('data-parent')) {
                $class_1.closest('.' + $class_1.attr('data-parent')).removeClass('open');
            }
        }
    }

    var $hDelivery = $('.hover_delivery');
    if($hDelivery.length) {
        $hDelivery.each(function () {
            var el_1 = $(this).find('.hover_class'),
                el_2 = $(this).find('.hover_css');

            hoverDelivery(el_1, el_2);
        })
    }


    $(window).scroll(function(){
        if (window.matchMedia('screen and (max-width: 991px)').matches) {
            if ($(window).scrollTop() > 0) {
                $('.main-nav__wrap').addClass('active');
                $('.header-mobile_bottom form.search').find('input[type=search]').val('')
                $('.header-mobile_bottom form.search').fadeOut(200);
            }
            else {
                $('.main-nav__wrap').removeClass('active');
            }
        }
    });


    /**
     * Owl carousel
     */
    const $homeSlider = $('.home_slider');
    $homeSlider.owlCarousel({
        loop:true,
        lazyLoad:true,
        margin: 0,
        nav:false,
        dots: true,
        autoplay: ($homeSlider.attr('data-autoplay') && $homeSlider.attr('data-autoplay') != '0') ? true : false,
        autoplayTimeout: $homeSlider.attr('data-pause'),
        autoplaySpeed: $homeSlider.attr('data-speed'),
        autoplayHoverPause: true,
        navText: ["<i class='icon-left'></i>","<i class='icon-right'></i>"],
        responsive:{
            0:{
                items:1,
                nav:false,
                dots: true,
            },
            992: {
                items:1,
                nav:true,
                dots: false,
                autoWidth: true,
            }
        }
    });
    //Navigate

        var width = $(window).width();

        const topslider = $('.info-slider-slider');
        let sliders = $('.info-slider-slider .item').length;
        const thumbnail = $('.info-slider-nav .info-slider-items');
        var indexSlideClick = "";

        thumbnail.owlCarousel({
            autoplay: false,
            autoWidth: true,
            dots: false,
            mouseDrag: true,
            touchDrag: true,
            margin: 12,
            navElement: 'div',
            navText: ["<div class='info-slider-prev'></div>", "<div class='info-slider-next'></div>"],
            items: 4,
            center: false,
            loop: false,
            nav: true,
            responsive: {
                0: {
                    margin: 12,
                    items: 4,
                },
                1690: {
                    margin: 20,
                    items: 5,
                }
            }

        }).on('click', '.info-slider-item', function (e) {
            var active = thumbnail.find('.owl-item .info-slider-item');
            for (var i = 0; i < active.length; i++) {
                if(active[i] == e.currentTarget){
                    indexSlideClick = i;
                    break
                }
            }
            topslider.trigger('to.owl.carousel', [indexSlideClick, 500, true]);
        });

        topslider.owlCarousel({
            autoWidth: false,
            autoplay: false,
            navText: ["<i class='icon-left'></i>", "<i class='icon-right'></i>"],
            mouseDrag: true,
            touchDrag: true,
            loop: false,
            lazyLoad: true,
            dots: false,
            items: 1,
            margin: 0,
            onInitialized: onInitializedSlider,
            animateOut: 'fadeOut',
            responsive: {
                0: {
                    dots: sliders > 1 ? true : false,
                },
                768: {
                    dots: false,
                    URLhashListener: true,
                    startPosition: 'URLHash',
                }
            }
        }).on('changed.owl.carousel', function (e) {
            thumbnail.trigger('to.owl.carousel', [e.item.index, 500, true]);
            $('.info-slider-nav .info-slider-item').removeClass('selected');
            $('.info-slider-nav .owl-stage').find(".owl-item:eq(" + e.item.index +") .info-slider-item").addClass('selected');
        });

        $('.info-slider-next').click(function () {
            topslider.trigger('next.owl.carousel');
            thumbnail.trigger('next.owl.carousel');
        });
        $('.info-slider-prev').click(function () {
            thumbnail.trigger('prev.owl.carousel');
            topslider.trigger('prev.owl.carousel');
        });

        window.dispatchEvent(new Event('resize'));
        function onInitializedSlider(evt) {
            $('.info-slider-nav .info-slider-item').removeClass('selected');
            $('.info-slider-nav .owl-stage').find(".owl-item:eq(" + evt.relatedTarget._current +") .info-slider-item").addClass('selected');
            if(evt.relatedTarget._current){
                thumbnail.trigger('to.owl.carousel', [evt.relatedTarget._current, 500, true])
            }
        }
    //Fix for apple
    if($(window).width() < 1200) {
        var options = {
            preventDefault: true
        };
        var reviewItem = document.querySelectorAll('.big_slider');
        for(var i = 0; i < reviewItem.length; i++) {
            var hammertime = new Hammer(reviewItem[i], options);
            hammertime.on("swipeleft swiperight", function(ev){});
        }
    }

    $( "#anchor_top, .anchor_top" ).click(function( event ) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 400);
    });

    $( ".search_anchor" ).click(function( event ) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 400);
        setTimeout(function() {
            $('.header-mobile_bottom .search_btn').trigger('click');
        }, 500);
    });

    $( ".quick_order_link" ).click(function( event ) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: $('.card_quick_order.lg-hidden').offset().top - 100 }, 400);
        $('.card_quick_order.lg-hidden').find('input').trigger('focus');
    });

    /**
     * product carousel
     */
    function initialProductSlider() {
        let $owlProducts = $('.carousel-product');

        if($(window).width() >= 1200) {
            $owlProducts.on('initialized.owl.carousel', function () {
                $owlProducts.find('.product-card').each(function () {
                    let self = $(this);
                    $(this).find('img').bind('load', function() {
                        self.parent().css('min-height', self.outerHeight());
                    });
                })
            });
        }

        if($('.catalog-page').length) {
            //Set min height for product`s block
            if($(window).width() >= 1200) {
                $('.product-card').each(function () {
                    let self = $(this);
                    $(this).find('img').bind('load', function() {
                        self.parent().css('min-height', self.outerHeight());
                    });
                });
            }

            $owlProducts.owlCarousel({
                dots: false,
                slideBy: 1,
                responsiveClass:true,
                navText: ["<i class='icon-left'></i>","<i class='icon-right'></i>"],
                responsive:{
                    0:{
                        items:1,
                        nav:true,
                    },
                    576:{
                        items:2,
                        nav:true,
                        autoWidth: false,
                    },
                    768:{
                        items:3,
                        nav:true,
                        autoWidth: false,
                    },
                    992:{
                        items:2,
                        nav:true,
                        autoWidth: false,
                    },
                    1200:{
                        items:3,
                        nav:true,
                        margin: 15,
                        autoWidth: false,
                    },
                    1280:{
                        items:3,
                        nav:true,
                        margin: 15,
                        autoWidth: false,
                    },
                    1680:{
                        items:4,
                        nav:true,
                        margin: 20,
                        autoWidth: false,
                    }
                }
            });

        } else {
            $owlProducts.owlCarousel({
                dots: false,
                slideBy: 1,
                responsiveClass:true,
                navText: ["<i class='icon-left'></i>","<i class='icon-right'></i>"],
                responsive:{
                    0:{
                        items:1,
                        nav:true,
                    },
                    768:{
                        items:2,
                        nav:true,
                        autoWidth: false,
                    },
                    874:{
                        items:3,
                        nav:true,
                        autoWidth: false,
                    },
                    992:{
                        items:3,
                        nav:true,
                        autoWidth: false,
                    },
                    1200:{
                        items:4,
                        nav:true,
                        // autoWidth: true,
                    },
                    1680:{
                        items:5,
                        nav:true,
                        margin: 20,
                        autoWidth: false,
                    }
                },
                onDrag: function() {
                    if ($('.carousel-product').data('owl.carousel').settings.items > 1) {
                        setTimeout(function() {
                            $('.carousel-product').trigger('refresh.owl.carousel')
                        }, 100)
                    }
                }
            });
        }

        if($(window).width() >= 1200) {
            $owlProducts.css('z-index', '0');
            $('.carousel-product').find('.product-card').on('mouseenter', function () {
                $(this).closest('.carousel-product').css('z-index', '2');
            }).on('mouseleave', function () {
                $(this).closest('.carousel-product').css('z-index', '0');
            });
        }
    }
    initialProductSlider();

    if($('#xhr-catalog-wrap').length) {
        $('#xhr-catalog-wrap').bind('initial.product.carousel', function () {
            initialProductSlider();
        });
    }


    /**
     * Drop down search
     */
    let $dropDownSearch = $('.drop_down_search');
    if($dropDownSearch.length) {
        $dropDownSearch.find('input').on('keyup', function () {

            let val = $(this).val().toLowerCase(),
                $searchThis = $(this).closest('.drop_down_search').find('.drop_down-list li'),
                found = 0;

            $searchThis.each(function () {
                if(!$(this).hasClass('empty')) {
                    if ($(this).html().toLowerCase().indexOf(val) === -1) {
                        $(this).css('display', 'none');
                    } else {
                        $(this).removeAttr('style').removeClass('active');
                        found++;
                    }
                }
            });

            if(found <= 0 && val.length > 0) {
                $(this).closest('.drop_down_search').find('.drop_down-list li.empty').removeAttr('style');
            } else {
                $(this).closest('.drop_down_search').find('.drop_down-list li.empty').css('display', 'none');
            }
        });
        $(document).on('mouseup', function (e) {
            var container = $(".drop_down_search");
            if (container.has(e.target).length === 0){
                container.removeClass('open');
                checkSelect();
            }
        });
    }

    /**
     * Drop down
     */
    var $dropDown = $('.drop_down');
    if($dropDown.length) {
        $('.drop_down-list').each(function() {
            if($(this).find('li.active').length) {
                var currentActive = $(this).find('li.active');
                currentActive.closest('.drop_down').find('.select span').html(currentActive.html());
            }
        });

        $('body').on('click', '.drop_down .drop_down-list li:not(.empty):not(.active):not(.info)', function () {
            if($(this).hasClass('active')) return false;

            if(!$(this).hasClass('reading')) {
                var selectedText = $(this).html();
                var selectedValue = $(this).attr('data-value');
                selectedValue = selectedValue || selectedText;
                $(this).closest('.drop_down').find('.select>span').html(selectedText);
                $(this).parent().find('li').removeClass('active');
                $(this).addClass('active');

                if ($(this).closest('.drop_down').find('>input[type=hidden]')) {
                    $(this).closest('.drop_down').find('>input[type=hidden]').val(selectedValue);
                }
                if (selectedValue) {
                    $(this).trigger('dropdown-change', [selectedValue]);
                }

                if ($(this).closest('.drop_down').hasClass('click_open')) {
                    $(this).closest('.drop_down').removeClass('open');
                }


                if($(this).closest('.drop_down-list').hasClass('delivery_type-block')) {
                    $(this).closest('form').find('.delivery_type').find('input').val($(this).attr('id'));
                    $(this).closest('form').find('.delivery_type').find('input').trigger('keyup');
                    // $(this).closest('form').find('.for-delivery').find('input').val('');
                    // $(this).closest('form').find('.for-nova-delivery').find('input').val('');

                    $(this).closest('form').find('.for-delivery-ukr').hide();

                    if($(this).attr('id') == 'nova') {
                        $(this).closest('form').find('.for-nova-delivery').show();
                        $(this).closest('form').find('.for-self').hide();
                        // $(this).closest('form').find('.for-delivery').hide().find('input').val('').removeAttr('placeholder');
                        $(this).closest('form').find('.for-delivery').hide();
                    } else if($(this).attr('id') == 'self') {
                        $(this).closest('form').find('.for-delivery').hide();
                        $(this).closest('form').find('.for-nova-delivery').hide();
                        $(this).closest('form').find('.for-self').show();
                    } else {
                        // $(this).closest('form').find('.for-nova-delivery').hide().find('input').val('').removeAttr('placeholder');
                        $(this).closest('form').find('.for-nova-delivery').hide();
                        $(this).closest('form').find('.for-self').hide();
                        $(this).closest('form').find('.for-delivery').show();

                        if($(this).attr('id') == 'ukr') {
                            $(this).closest('form').find('.for-delivery-ukr').show();
                        }
                    }
                }

                if($(this).closest('.drop_down-list').hasClass('pay_type-block')) {
                    $('.pay_type').find('input').val($(this).attr('id'));
                    $('.pay_type').find('input').trigger('keyup');
                }

                if($(this).closest('.drop_down-list').hasClass('pay_type-block')) {
                    $(this).closest('#pay_form').find('.pay_type').find('label.error').hide();
                }
            }

            if($(this).closest('.wrap_popup').hasClass('address-modal')) {
                calcSetTopHeight($(this).closest('.wrap_popup'));
            }

        });
        $('body').on('click', '.drop_down-list li:not(.active):not(.empty):not(.info)', function () {
            let value = $(this).html();
            $(this).parent().find('li').removeClass('active');
            $(this).addClass('active');

            $(this).closest('.drop_down').find('input:not([type=hidden])').val(value).attr('data-id', $(this).attr('data-id'));
            $(this).closest('.drop_down').removeClass('open');

            $(this).closest('.drop_down-list').siblings('.form-group').find('input').trigger('blur');
        });

        //For open after click
        var $headerDropDown = $('.drop_down.click_open');
        $('body').on('click', '.drop_down.click_open > .select', function () {
            if($(this).parent().hasClass('disabled')) return false;

            $headerDropDown.find(' > .select').not($(this)).parent().removeClass('open');
            $(this).parent().toggleClass('open');

            //Set focus if this block has search area
            if($(this).closest('.drop_down ').hasClass('drop_down_search')) {
                $(this).closest('.drop_down ').find('input.search_box').focus();
            }
        });
        //For open after click
        $('body').on('click', '.drop_down input', function () {
            if($(this).closest('.drop_down').hasClass('disabled')) return false;
            $dropDown.not($(this).closest('.drop_down')).removeClass('open');
            $(this).closest('.drop_down').toggleClass('open');

            //Toggle focus
            if($(this).is(":focus") && !$(this).closest('.drop_down').hasClass('open')) {
                $(this).blur();
                checkSelect();
            } else {
                $(this).focus();
            }
        });

        $('.icon-down').on('click', function() {
            $(this).siblings('input').trigger('click');
        })

        $(document).on('mouseup', function (e) {
            var container = $(".drop_down");
            if (container.has(e.target).length === 0){
                container.removeClass('open');
                checkSelect();
            }
        });
    }

    /**
     * Clear value if user dosen`t selected or search was empty.
     */
    function checkSelect() {
        $('body').find('.drop_down').each(function () {
            if($(this).hasClass('drop_down_city') && $('#account_city_hidden').val().length){
                return false
            }
            if($(this).find('.drop_down-list li.active').length === 0) {
                $(this).find('input').val(''); //NOTE: reset input if the user entered trash to input
                $(this).find('ul li').removeAttr('style');
                $(this).find('ul li.empty').css('display', 'none');
            }
        });
    }

    $('form.validate').each(function () {
        let $validator = $(this).validate({
            highlight: function(element) {
                $(element).addClass("valid-error").removeClass("success");
            },
            unhighlight: function(element) {
                $(element).removeClass("valid-error").addClass("success");
            },
            errorPlacement: function(error,element) {
                if (element.attr("data-no-message") !== undefined) {
                    return true;
                } else {
                    error.insertAfter(element);
                }
            },
            rules: {
                password_confirmation: {
                    equalTo: ".password_first"
                }
            },

            //Send form
            submitHandler: function(form){

                if($(form).hasClass('validate-submit')){
                    return false;
                }
                let action = $(form).attr('action'),
                    formData = new FormData($(form)[0]),
                    $generalError = $(form).find('.general-error');

                $generalError.fadeOut(100);
                $(form).find('button[type="submit"]').prop('disabled', true);

                if($(form).hasClass('quick_order')) {
                    new CartActions().checkAvailableProducts(function (res) {
                        if (res.data.html) {
                            $('#available-warn .modal-body').html(res.data.html);
                            $(document).trigger('trigger.show.popup', ['available-warn']);
                            $(form).find('button[type="submit"]').prop('disabled', false);
                        } else {
                            callHandler();
                        }
                    });
                } else {
                    callHandler();
                }

                function callHandler() {

                    //Add more data if not exist
                    if(window.popupMoreInfo && window.popupMoreInfo !== null) {
                        for (let property in window.popupMoreInfo) {
                            formData.append(property, window.popupMoreInfo[property]);
                        }
                    }

                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        data: formData,
                        dataType: "json",
                        success: function(res, textStatus, jqXHR) {
                            console.log('res ', res);
                            if(res.success) {
                                if(res.data && res.data.url) {
                                    window.location.href = res.data.url;
                                }

                                if(res.data && res.data.timer_url) {
                                    setTimeout(function () {
                                        window.location.href = res.data.timer_url;
                                    }, 1500);
                                }

                                //Next popup
                                if(res.data && res.data.show_next) {
                                    $(form).closest('.wrap_popup').fadeOut(function () {
                                        let $blShow =  $('#' + res.data.show_next);
                                        if(res.data.show_text) {
                                            $blShow.find('#xhr-th-text').html(res.data.show_text);
                                        }
                                        $blShow.fadeIn();
                                    });
                                }

                                //Trigger popup
                                if(res.data && res.data.trigger_popup) {
                                    if(res.data.show_text) {
                                        $('#' + res.data.trigger_popup).find('#xhr-th-text').html(res.data.show_text);
                                    }
                                    $(document).trigger('trigger.show.popup', [res.data.trigger_popup]);
                                }

                                if($(form).closest('.wrap_popup').hasClass('callback-modal')) {
                                    $(form).closest('.wrap_popup').find('.step1').hide();
                                    $(form).closest('.wrap_popup').find('.step2').show();
                                    $('.wrap_popup').each(function () {
                                        var $el = $(this);
                                        calcSetTopHeight($el);
                                    });

                                    window.GA.pushFormOk('form_send_ok');
                                }

                                if($(form).hasClass('clear_form_and_show_ok')) {
                                    $(form).find('input').val('');
                                    $(form).find('textarea').val('');
                                    $('#ok-modal').show();
                                }
                            } else {
                                $generalError.find('label').html(res.message).show();
                                $generalError.fadeIn(100);
                            }

                            $(form).find('button[type="submit"]').prop('disabled', false);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            if(jqXHR.status === 422) {
                                let errorObj = {};
                                if(jqXHR.responseJSON.errors) {
                                    const objErrors = jqXHR.responseJSON.errors;
                                    for (let property in objErrors) {
                                        errorObj[property] = objErrors[property].join(',');
                                    }
                                }
                                $validator.showErrors(errorObj);
                            }

                            $(form).find('button[type="submit"]').prop('disabled', false);
                        }
                    });
                }
            }
        });
    });

    /**
     * Load more reviews
     * @type {jQuery|HTMLElement}
     */
    let $loadMoreReview = $('.load-more-review');
    if($loadMoreReview.length) {
        $loadMoreReview.on('click', function () {
            let self = $(this),
                max = Number(self.attr('data-max')),
                formData = new FormData();

            self.prop('disabled', true);
            formData.append('offset', self.attr('data-offer'));
            formData.append('product_id', self.attr('data-product-id'));
            formData.append('type_id', self.attr('data-product-type'));

            $.ajax({
                type: "POST",
                url: self.attr('data-url'),
                processData: false,
                contentType: false,
                data: formData
            }).done(function (res) {
                self.prop('disabled', false);
                if(res.success) {
                    self.parent().siblings('.comments-list').append(res.data.data);
                    if(res.data.offers >= max) {
                        self.parent().remove();
                    } else {
                        self.attr('data-offer', res.data.offers);
                    }
                    return true;
                }
                alert('Ooops. Some Error.');
            });
        })
    }

    /**
     * Open|Close popups
     */
    $('.wrap_container').on('click', '.open-popup', function (e) {
        let $this = $(this);
        if(!$this.hasClass('open-popup-continue')){
            e.preventDefault();
        };
        $('.cookie-info').fadeOut(300);
        initTriggerPopup($this);
    });

    //NOTE: trigger for show popup, just pass ID
    $(document).bind('trigger.show.popup', function (e, id) {
        let $thisEl = document.createElement('div');
        $thisEl.setAttribute('data-popup', id);
        initTriggerPopup($($thisEl));
    });

    function initTriggerPopup($this) {
        if($this.hasClass('disabled')) return false;

        if($this.hasClass('subscribe-btn') && !$this.closest('.subscribe-form').valid()) return false;

        //Save to global variable some value from button
        if($this.attr('data-insert')) {
            window.popupMoreInfo = JSON.parse($this.attr('data-insert'));
        } else {
            window.popupMoreInfo = null;
        }

        openPopups($this);
    }

    //Close this popup with button class
    $('.close_this_popup').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.wrap_popup').find('.close').trigger('click');
    });


    function openPopups($this) {

        //console.log($this);

        if($this.attr('data-popup') == 'addressEdit') {
            if($('#addressEdit .delivery_type').find('input').val() == 'nova') {
                $('#addressEdit .for-nova-delivery').show();
                $('#addressEdit .for-self').hide();
                // $('#addressEdit .for-delivery').hide().find('input').val('');
                $('#addressEdit .for-delivery').hide()
            } else if($('#addressEdit .delivery_type').find('input').val() == 'self'){
                $('#addressEdit .for-nova-delivery').hide();
                $('#addressEdit .for-delivery').hide();
                $('#addressEdit .for-self').show();

            } else {
                // $('#addressEdit .for-nova-delivery').hide().find('input').val('');
                $('#addressEdit .for-nova-delivery').hide();
                $('#addressEdit .for-self').hide();
                $('#addressEdit .for-delivery').show();

                if($('#addressEdit .delivery_type').find('input').val() == 'ukr') {
                    $('#addressEdit .for-delivery-ukr').show();
                }
            }
        }

        if($this.attr('data-popup') == 'settingsCookie') {
            setTimeout(function () {
                $("#settingsCookie .modal-content-scroll").mCustomScrollbar({
                    theme: "minimal-dark",
                    autoHideScrollbar: false,
                    scrollInertia: 0,
                    advanced:{ autoUpdateTimeout: 500 }
                });
            }, 0);

            $('.overlay_page, #' + $this.attr('data-popup')).fadeIn(200, function() {

                calcSetTopHeight($('#'+ $this.attr('data-popup')));
            });
        }

        if($this.attr('data-popup') == 'cartModal') {
            setTimeout(function () {
                $("#cartModal .cart-list-wrap").mCustomScrollbar({
                    theme: "minimal-dark",
                    autoHideScrollbar: false,
                    scrollInertia: 0
                });
            }, 0);

            $('.overlay_page, #' + $this.attr('data-popup')).fadeIn(200, function() {

                calcSetTopHeight($('#'+ $this.attr('data-popup')));
            });
        }

        if($this.attr('data-popup') == 'signIn') {
            clearTimerPopup();
            $('#signInTel').val('').removeClass('valid-error');
            $('#signInTel-error').remove();
            if($('.menu').hasClass('show')){
                $('.menu-btn').trigger('click');
            }
        }

        if($this.attr('data-popup') == 'signInSms') {
            if($this.closest('form').valid()){
                $this.closest('form').find('input').removeClass('valid-error');
                $this.closest('form').find('label.error').remove();
            } else {
                return false;
            }
        }

        if($this.attr('data-popup') == 'phoneChange') {
            clearTimerPopup();
            $('#phoneChangeNew').val('').removeClass('valid-error');
            $('#phoneChangeNew-error').remove();
        }

        if($this.attr('data-popup') == 'phoneChangeSms') {
            if($this.closest('form').valid()){
                $this.closest('form').find('input').removeClass('valid-error');
                $this.closest('form').find('label.error').remove();
            } else {
                return false;
            }
        }

        if($this.attr('data-popup') == 'accountRegister') {
            clearTimerPopup();
        }
        if($this.attr('data-popup') == 'registerSms') {
            if($this.closest('form').valid()){
                console.log('remove');
                $this.closest('form').find('input').removeClass('valid-error');
                $this.closest('form').find('label.error').remove();
            } else {
                return false;
            }
        }

        if($this.attr('data-close-menu')) {
            $('.close_menu').trigger('click');
        }


        // ignore ajax case
        if( $this.closest('.wrap_popup').hasClass('signIn-modal') ){
            if ($this.hasClass('signin-to-register')){
                calcSetTopHeight($('#accountRegister'));
                $('#accountRegister').fadeIn(200);
            };
            return false;
        }
        if( $this.closest('.wrap_popup').hasClass('register-modal')){
            if ($this.hasClass('register-to-signin')){
                calcSetTopHeight($('#signIn'));
                $('#accountRegister').fadeOut(200);
                $('#signIn').fadeIn(200);
            };
            return false;
        }
        if( $this.closest('.wrap_popup').hasClass('registerSms-modal')){
            if ($this.hasClass('sms-to-register')){
                calcSetTopHeight($('#accountRegister'));
                $('#registerSms').fadeOut(200);
                $('#accountRegister').fadeIn(200);
            };
            return false;
        }
        if ($this.hasClass('profile-phone-to-conform')){
            return false;
        };


        if( $this.attr('data-step') || $this.closest('.wrap_popup').hasClass('cart-modal') ) {
            $this.closest('.wrap_popup').fadeOut(200, function () {
                calcSetTopHeight($('#'+ $this.attr('data-popup')));
                $('#' +$this.attr('data-popup')).fadeIn(200);
            })
        } else {
            calcSetTopHeight($('#'+ $this.attr('data-popup')));
            $('.overlay_page, #' + $this.attr('data-popup')).fadeIn(200);
        }


        globalStopScroll = new StopScroll($('#' + $this.attr('data-popup')), '.wrap_popup');
        globalStopScroll.disableScroll();

        // if(window.innerWidth < 1092){
        //     overlayOpen();
        // } else {
             //disable_scroll();
        //     // $('body').css({'overflow': 'hidden', 'height': '100%'});
        //     // $('html').css({'overflow': 'hidden'});
        // }

        //Set active to first input
        setTimeout(function () {
            $('#' + $this.attr('data-popup')).find('form input:not([type="hidden"])').first().focus();
        }, 250);
    }

    function calcSetTopHeight($el) {
        if($(window).width() >= 767 ) {
            var width = $el.outerWidth() / 2,
                height = $el.outerHeight() / 2,
                windowH = $(window).height() / 2,
                windowW = $(window).width() / 2,
                top = windowH - height,
                left = windowW - width;

            $el.css('top', top + 'px');
            $el.css({
                'top': top + 'px',
                'left': left + 'px',
            });
        }
    }

    $('.wrap_popup').each(function () {
        var $el = $(this);
        calcSetTopHeight($el);
    });

    $('.wrap_popup .close, .overlay_page').on('click', function (e) {
        e.preventDefault();

        if($('#settingsCookie').css('display') == 'block') {
            if(e.target.classList.contains('overlay_page')){
                return false
            }
            if ($.cookie('acceptCookie') == null && $.cookie('rejectCookie') == null && $.cookie('cookiesSettings') == null) {
                $('.cookie-info').fadeIn(300);
            }
        }
        // For cart model warning
        if($(this).closest('.wrap_popup').hasClass('close-only-this')) {
            var $this = $(this);
            $(this).closest('.wrap_popup').fadeOut(200, function () {
                if($this.closest('.wrap_popup').hasClass('show-cart-then')) {
                    $this.closest('.wrap_popup').removeClass('close-only-this show-cart-then');
                    $('#cartModal').removeClass('hide-for-next-popup');
                }
            });
            return false;
        }


        $('.overlay_page, .wrap_popup').fadeOut(200, function () {

            if($(this).hasClass('callback-modal')) {
                $(this).closest('.wrap_popup').find('.step1').show();
                $(this).closest('.wrap_popup').find('.step2').hide();
                $(this).find('form')[0].reset();
            }

            if($(this).hasClass('review-modal')) {
                $(this).find('.product-card__star a').removeClass();
                $(this).find('.rating-block input').attr('value', '');
                $(this).find('form')[0].reset();
            }
            if($(this).hasClass('signInSms-modal')) {
                var $this = $(this);
                setTimeout(function () {
                    clearTimerPopup();
                    $this.find('form')[0].reset();
                    $this.closest('form').find('input').removeClass('valid-error');
                    $this.closest('form').find('label.error').remove();
                }, 200);
            }

            if($(this).hasClass('signIn-modal')) {
                console.log('clear signIn-modal');
                var $this = $(this);
                setTimeout(function () {
                    $this.find('form')[0].reset();
                    $this.closest('form').find('input').removeClass('valid-error').removeClass('error');
                    $this.closest('form').find('label.error').remove();
                    $('#phone-error').remove();
                }, 200);
            }

            if($(this).hasClass('phoneChangeSms-modal')) {
                var $this = $(this);
                setTimeout(function () {
                    clearTimerPopup();
                    $this.find('form')[0].reset();
                    $this.closest('form').find('input').removeClass('valid-error');
                    $this.closest('form').find('label.error').remove();
                }, 200);
            }

            if($(this).hasClass('phoneChange-modal')) {
                console.log('clear phoneChange-modal');
                var $this = $(this);
                setTimeout(function () {
                    $this.find('form')[0].reset();
                    $this.closest('form').find('input').removeClass('valid-error').removeClass('error');
                    $this.closest('form').find('label.error').remove();
                    $('#phone-error').remove();
                }, 200);
            }

            if( $(this).find('.thanks').length) {
                $(this).find('form')[0].reset();
                $(this).find('form').css('opacity', 1).find('button[type=submit], input').prop('disabled', false);
                $(this).find('.thanks').css('display', 'none');
            }

            if( $(this).hasClass('instruction-modal') ) {
                $("#instructionVideo iframe").attr("src", $("#instructionVideo iframe").attr("src"));
            }

            if( $(this).hasClass('cart-modal') ) {
                $('#cartModal .cart-list-wrap').mCustomScrollbar('destroy');
                document.querySelector("#cartModal").style.left = "0";
                document.querySelector("#cartModal").style.top = "0";
            }
        });

        //Stop video in frame
        $('.wrap_popup iframe').each(function(){
            let el_src = $(this).attr("src");
            $(this).attr("src", el_src);
        });

        if(globalStopScroll) {
            globalStopScroll.enableScroll();
        }
    });

    $('.top-submenu-link').on('click', function() {
        $(this).toggleClass('open');
    });

    $(document).on('mouseup', function (e) {
        var container = $(".top-submenu-link"),
            submenu = container.siblings(".header-list");
        if (!container.is(e.target) && container.has(e.target).length === 0 && submenu.has(e.target).length === 0){
            container.removeClass('open');
        }
    });

    // Accordion
    var listHeight;
    $('.accordion-link').on('click touch', function(e) {
        if(!e.target.classList.contains('accordion-prevent')){
            if(!$(this).hasClass('accordion-link-cat-js')){
                e.preventDefault();
                $(this).removeClass('accordion-link-cat-js');
            }
            // e.preventDefault();
            if($(this).hasClass('opened') && !$(this).hasClass('accordion-link-cat')) {
                $(this).removeClass('opened');
                if($(this).hasClass('menu__link')) {
                    $(this).next('.accordion-link-toggle').css({'height': '0'});
                } else {
                    $(this).next('.accordion-link-toggle').css({'height': '0', 'margin-bottom': '0'});
                }
            } else {
                $(this).addClass('opened');
                listHeight = $(this).next('.accordion-link-toggle').prop('scrollHeight');
                if($(this).hasClass('menu__link') ||  $(this).hasClass('cookie__link')) {
                    $(this).next('.accordion-link-toggle').css({'height': listHeight});
                } else {
                    $(this).next('.accordion-link-toggle').css({'height': listHeight, 'margin-bottom': '20px'});
                }
            }
        }
    });

    if($(window).width() > 991) {
        $(".menu").mCustomScrollbar({
            theme: "minimal-dark",
            autoHideScrollbar: false,
            scrollInertia: 0
        });
        $(".filter-blog").mCustomScrollbar({
          theme: "minimal-dark",
          autoHideScrollbar: false,
          scrollInertia: 0
        });
    }

    /**
     * Mobile menu and other controls
     */
    if($(window).width() < 1200) {
        /**
         * toggle menu
         */
        $('.menu-btn').click(function (e) {
            e.preventDefault();
            if (!$('.menu').hasClass('show')) {
                $('.menu').addClass('show');
                if(window.innerWidth > 1199){
                    $('body').css({'padding-right': '17px'});
                }

                if(window.innerWidth < 992){
                    overlayOpen();
                } else {
                    disable_scroll();
                    // $('body').css({'overflow': 'hidden', 'height': '100%'});
                    // $('html').css({'overflow': 'hidden'});
                }
            } else {
                $('.menu').removeClass('show');
                $('body').css({'padding-right': '0'});

                if(window.innerWidth < 992){
                    overlayClose();
                } else {
                    enable_scroll_mobile();
                    // $('body').css({'overflow': 'auto', 'height': 'auto'});
                }

            }

            if(!$('.overlay_page').hasClass('showed')) {
                $('.overlay_page').fadeIn(200).addClass('showed');
            } else {
                $('.overlay_page').fadeOut(0).removeClass('showed');
            }
        });
        $('.menu .btn-close').on('click', function() {
            $('.menu-btn').trigger('click');
        });
        $('.filter-button, .filter-block .btn-close, .filter_anchor').click(function (e) {
            e.preventDefault();
            if (!$('.filter-block').hasClass('show')) {
                $('.filter-block').addClass('show');
                if(window.innerWidth > 1199){
                    $('body').css({'padding-right': '17px'});
                }

                if(window.innerWidth < 992){
                    overlayOpen();
                } else {
                    disable_scroll();
                }
            } else {
                $('.filter-block').removeClass('show');
                $('body').css({'padding-right': '0'});

                if(window.innerWidth < 992){
                    overlayClose();
                } else {
                    enable_scroll();
                }

            }

            if(!$('.overlay_page').hasClass('showed')) {
                $('.overlay_page').fadeIn(200).addClass('showed');
            } else {
                $('.overlay_page').fadeOut(0).removeClass('showed');
            }
        });


        $('.sort-button').click(function (e) {
            e.preventDefault();
            if (!$('.sort-block').hasClass('show')) {
                $('.sort-block').addClass('show');
                if(window.innerWidth > 1199){
                    $('body').css({'padding-right': '17px'});
                }

                if(window.innerWidth < 992){
                    overlayOpen();
                } else {
                    disable_scroll();
                    // $('body').css({'overflow': 'hidden', 'height': '100%'});
                    // $('html').css({'overflow': 'hidden'});
                }
            } else {
                $('.sort-block').removeClass('show');
                $('body').css({'padding-right': '0'});

                if(window.innerWidth < 992){
                    overlayClose();
                } else {
                    enable_scroll();
                    // $('body').css({'overflow': 'auto', 'height': 'auto'});
                }

            }

            if(!$('.overlay_page').hasClass('showed')) {
                $('.overlay_page').fadeIn(200).addClass('showed');
            } else {
                $('.overlay_page').fadeOut(0).removeClass('showed');
            }
        });
        $('.sort-block .btn-close').on('click', function() {
            $('.sort-button').trigger('click');
        });
        $('.blog-sidebar-mobile').click(function (e) {
          e.preventDefault();
          if (!$('.filter-blog').hasClass('show')) {
             $('.filter-blog').addClass('show');

             if(window.innerWidth < 992){
                overlayOpen();
             } else {
                disable_scroll();
             }
          } else {
             $('.filter-blog').removeClass('show');
             if(window.innerWidth < 992){
                overlayClose();
             } else {
                enable_scroll();
             }
          }

          if(!$('.overlay_page').hasClass('showed')) {
             $('.overlay_page').fadeIn(200).addClass('showed');
          } else {
             $('.overlay_page').fadeOut(0).removeClass('showed');
          }
        });
    $('.filter-blog .btn-close').on('click', function() {
       $('.blog-sidebar-mobile').trigger('click');
    });

        //Search
        var $search = $('.header-mobile_bottom .search_btn'),
            $searchForm = $('.header-mobile_bottom form.search'),
            $clearForm = $('.header-mobile_bottom form.search .clear_form'),
            $menuLogo = $('.header_mobile .big_catalog, .header_mobile .logo');

        $search.on('click', function (e) {
            e.preventDefault();
            $menuLogo.animate({opacity: 0}, 100);
            $searchForm.fadeIn(200).css('display', 'flex');
            $searchForm.find('input').trigger('focus');
        });
        $clearForm.on('click', function () {
            $(this).parent().find('input[type=search]').val('');
            $searchForm.fadeOut(200);
            $menuLogo.animate({opacity: 1}, 100);
        });

        $(document).mouseup(function (e) {
            if ($searchForm.has(e.target).length === 0){
                $searchForm.fadeOut(200);
                $menuLogo.animate({opacity: 1}, 100);
            }
        });
    }

    /**
     *
     * Counter
     */
    $(document).on('click', '.counter span:not(.disabled)', function () {
        var $input = $(this).siblings('input'),
            value = Number($input.val()),
            min = Number($input.attr('data-min')),
            max = Number($input.attr('data-max')),
            typeAction = $(this).attr('data-attr');

        if(typeAction === 'plus' && value < max) {
            $input.val(++value);
        } else if (typeAction === 'minus' && value > min) {
            $input.val(--value);
        }

        if(value >= max) {
            $(this).closest('.counter').find('span[data-attr="plus"]').addClass('disabled');
        } else {
            $(this).closest('.counter').find('span[data-attr="plus"]').removeClass('disabled');
        }

        if(value <= 1) {
            $(this).closest('.counter').find('span[data-attr="minus"]').addClass('disabled');
        } else {
            $(this).closest('.counter').find('span[data-attr="minus"]').removeClass('disabled');
        }
        $(this).closest('.counter').find('input').trigger('change');

        //Save count
        let id = $(this).closest('.cart-item').attr('data-id');
        $(document).trigger('trigger.count.product', [id, Number(value)]);
    });

    $(document).on('input  keypress keyup blur', '.counter input', function (event) {
        // $(this).val($(this).val().replace(/([^0-9]+)/gi, ""));
        var current = $(this).val();
        var corrected = parseInt(current.replace(/([^0-9]+)/gi, ''));

        if(isNaN(corrected)) {
            $(this).val('1');
        } else {
            $(this).val(corrected);
        }
        if ((event.which < 48 || event.which > 57)) {
            event.preventDefault();

            if(current && current > 0) {
                let id = $(this).closest('.cart-item').attr('data-id');
                $(document).trigger('trigger.count.product', [id, Number(current)]);
            }
        }
    });

    $(document).on('blur', '.counter input', function () {
        let max = Number($(this).attr('data-max'));

        if(Number($(this).val()) < Number($(this).attr('data-min'))) {
            $(this).val($(this).attr('data-min'));
            $(this).closest('.counter').find('span[data-attr="minus"]').addClass('disabled');
        } else {
            $(this).closest('.counter').find('span[data-attr="minus"]').removeClass('disabled');
        }

        if(Number($(this).val()) > max) {
            $(this).val(max);
            $(this).closest('.counter').find('span[data-attr="plus"]').addClass('disabled');
        } else {
            $(this).closest('.counter').find('span[data-attr="plus"]').removeClass('disabled');
        }
    });

    if($(window).width() <= 992) {
        $(".product-tabs > .tabs_area > .tabs_control").mCustomScrollbar({
            theme: "minimal-dark",
            axis:"x",
            autoHideScrollbar: false,
            advanced:{
                autoExpandHorizontalScroll:true
            }
        });
    }

    // Tabs
    let $tabsWrap = $('.tabs_area');
    if($tabsWrap.length) {
        $tabsWrap.on('click', '.tabs_control [data-id]:not(.active)', function (e) {
            e.preventDefault();
            let $this = $(this);
            $this.closest('.tabs_control').find('[data-id]').removeClass('active');
            $this.addClass('active');

            let $content = $this.closest('.tabs_area');
            $content.children('.tabs_content').children(' div:not(#'+ $this.attr('data-id') +')').fadeOut(0, function () {
                $content.find('#' + $this.attr('data-id')).fadeIn(200).addClass('showed');
            }).removeClass('showed');

            //Set hash
            let href = $(this).attr('href');
            if($(href).length) {
                history.pushState({}, '', href);
            }
        });
    }

    $('.reviews_anchor').on('click', function() {
        reviewsAnchor('#reviews');
    });

    if($('.product-tabs').length && window.location.hash) {
        reviewsAnchor(window.location.hash);
    }

    function reviewsAnchor(hash) {
        if(!['#descriptions', '#reviews', '#manuals'].includes(hash)) return true;

        if($(window).width() <= 992) {
            $('html,body').animate({scrollTop: $('.product-tabs').offset().top - 90}, 400, 'linear');
        } else {
            $('html,body').animate({scrollTop: $('.product-tabs').offset().top}, 400, 'linear');
        }
        //
        $('a[href="'+ hash +'"]').trigger('click');
    }

    // Rating stars
    if($(window).width() <= 992) {
        $('.rating-block a').click(
        function(){
            $(this).parent().find('.active').removeClass('active');
            $(this).prevAll().addClass('active');
            $(this).addClass('active');
            $(this).closest('.rating-block').find('input').attr('value', $(this).index() + 1);
            $(this).closest('.rating-block').find('#rating-error').hide();
        });
    } else {
        $('.rating-block a').hover(
        function(){
            $(this).nextAll().addClass('blur');
            $(this).prevAll().addClass('hovered');
            $(this).addClass('hovered');
        },
        function(){
            $(this).prevAll().removeClass('hovered');
            $(this).nextAll().removeClass('hovered');
            $(this).nextAll().removeClass('blur');
            $(this).removeClass('hovered');
            $(this).removeClass('blur');
        }).click(
        function(){
            $(this).parent().find('.active').removeClass('active');
            $(this).prevAll().addClass('active');
            $(this).addClass('active');
            $(this).closest('.rating-block').find('input').attr('value', $(this).index() + 1);
            $(this).closest('.rating-block').find('#rating-error').hide();
        });

    }


    //cart count
            // var calculateCart;
    function calculateCart() {
        var cartLength =  function () {
            var count = 0;
            $('.cart-list .cart-item .counter input').each(function() {
                count+= Number($(this).val());
            });
            return count;
        };

        if(!cartLength){
            $('.cart-modal .btn').addClass('disabled');
        } else {
            $('.cart-modal .btn').removeClass('disabled');
        }
    };

    //cart calulate
    function calculateCartTotal() {
        var cartSumm1 =  function () {
            var countTotal1 = 0;
            if($('.cart-page').length) {
                $('.cart-page .cart-list .cart-item').each(function() {
                    countTotal1 += parseFloat($(this).find('.amount-sum').text().replace(/\s/g, '').replace(',', '.'));
                });
            }
            return countTotal1;
        }();
        var cartTotal1 = $('.cart-page .cart-total__sum');
        cartTotal1.text(priceFormat(cartSumm1));

        var cartSumm2 =  function () {
            var countTotal2 = 0;
            if($('.cart-modal').length) {
                $('.cart-modal .cart-list .cart-item').each(function() {
                    countTotal2 += parseFloat($(this).find('.amount-sum').text().replace(/\s/g, '').replace(',', '.'));
                });
            }
            return countTotal2;
        }();
        var cartTotal2 = $('.cart-modal .cart-total__sum');
        cartTotal2.text(priceFormat(cartSumm2));

        var cartSumm3 =  function () {
            var countTotal3 = 0;
            if($('.small_list_order').length) {
                $('.small_list_order .cart-list .cart-item').each(function() {
                    countTotal3 += parseFloat($(this).find('.amount-sum').text().replace(/\s/g, '').replace(',', '.'));
                    //todo: краще перенести в адтрибути, і брати з них.
                    // let number = parseFloat($(this).find('.amount-sum').text().replace(/\s/g, '').replace(',', '.'));
                    // countTotal3 += number;
                });
            }
            return countTotal3;
        }();
        var cartTotal3 = $('.small_list_order .cart-total__sum, .total_list .cart-total__sum');

        //Promo Codes
        let $promoCodes = $('.promocode-list');
        if($promoCodes.length) {
            $promoCodes.find('li').each(function () {
                let val = $(this).attr('data-val');
                if($(this).attr('data-type') === '1') {
                    cartSumm3 = cartSumm3 - ((val / 100) * cartSumm3);
                } else if($(this).attr('data-type') === '2') {
                    cartSumm3 = cartSumm3 - val;
                }
            });
        }

        cartTotal3.text(priceFormat(cartSumm3));
        cartTotal3.attr('data-price', cartSumm3);

        $(document).trigger('trigger.cart.calculated');
    };
    calculateCartTotal();

    // Calculate service
    function calcService(el) {
        var textService = $(el).closest('.cart-list');
        var multipleService = $(el).parent('.counter').find('input').val();
        if(multipleService == 0) {
            multipleService = 1;
        }

        var textServ = parseFloat($(el).closest('.cart-item__details').find('.amount-price').text().replace(/\s/g, '').replace(',', '.'));
        var totalServ = textServ * multipleService;
        $(el).closest('.cart-item__details').find('.amount-sum').text(priceFormat(totalServ));
    };

    $('.counter').find('input').on('change blur', function() {
        calcService(this);
        calculateCart();
        calculateCartTotal();
    });

    $(document).bind('trigger.update.price.count', function () {
        $('.cart-list').find('input').each(function() {
            calcService(this);
            calculateCart();
            calculateCartTotal();
        });
    })

    $(window).on('load', function () {
       $(document).trigger('trigger.update.price.count');
    });
    $('.cart-list').find('input').each(function() {
        calcService(this);
        calculateCart();
        calculateCartTotal();
    });

    $('body').on('click', '.cart-item .btn-close', function() {
        var $this = $(this).closest('.cart-item');

        $('#deleteModal .btn').on('click', function() {
            $(this).closest('.wrap_popup').find('.close').trigger('click');
            $this.remove();
            calculateCart();
            calculateCartTotal();
        });
    });


    if($(window).width() >= 1200) {
        $('.product-card').on('mouseleave', function() {
            $(this).find('.drop_down').removeClass('open');
        })
    }

    $('[data-popup="cartModal"]').on('click', function() {
        if($('.cart-modal .cart-list').closest('.cart-list').find('.cart-item').length == 0) {
            $('.cart-modal .cart-list').closest('.cart-list').find('.empty-text').show();
        }

        if($(window).width() >= 992) {
            setTimeout(function () {
                $("#cartModal .cart-list-wrap").mCustomScrollbar({
                    theme: "minimal-dark",
                    autoHideScrollbar: false,
                    scrollInertia: 0
                });
            }, 0);
        }
    });


    // Account accordion

    // let $tabArea = $('.tab_area');
    if($tabArea.length) {
        $tabArea.on('click', '.tab_header', function() {
            $(this).siblings('.tab_controls').find('.active').removeClass('active');
            $(this).siblings('.tab_controls').find('[data-id="' + $(this).next('.tab_content').attr('id') + '"]').addClass('active');

            $(this).siblings('.tab_header.open').next('.tab_content').slideUp(200);
            $(this).siblings('.tab_header.open').removeClass('open');

            $(this).toggleClass('open');
            $(this).next('.tab_content').slideToggle(200);


            if($(this).next('.tab_content').attr('id') == 'favorites-list') {
                if(!$('#favorites-list .favorites-list li').length) {
                    $('#favorites-list .left-list').hide();
                    $('#favorites-list .text-empty').show();
                }
            }
        });
    }

    var maxdate = new Date();
    // maxdate.setDate(maxdate.getDate() - 1); //максимальный день - вчера
    $('.datepicker-here').each(function () {
        let $thisDate = $(this).datepicker({
            maxDate: maxdate,
        });
        if($(this).attr('value') && $(this).attr('value') !== '') {
            let dateArr = $(this).attr('value').split('.');
            $thisDate.data('datepicker').selectDate(new Date(dateArr[2], dateArr[1] - 1, dateArr[0]));
        }
    });

    $('.cancel-changes').on('click', function() {
        $(this).closest('form').find('input:checked').prop("checked", false);
        $(this).siblings('button').trigger('click');
    });

    $('#address-book .delete-address').on('click', function() {
        $(this).closest('.select_address-group').remove();
    });


    var currentFav = $('.favorites-list-number').closest('.favorites-list-title').siblings('.favorites-list').find('.favorite-item').length;
    $('.favorites-list-number').html(currentFav);

    $('#favorites-list .delete-item').on('click', function() {
        $(this).closest('.favorite-item').remove();
        currentFav = $('.favorites-list-number').closest('.favorites-list-title').siblings('.favorites-list').find('.favorite-item').length;
        $('.favorites-list-number').html(currentFav);

        if(!$('#favorites-list .favorites-list li').length) {
            $('#favorites-list .left-list').hide();
            $('#favorites-list .text-empty').show();
        }
    });

    $('#orders-history .delete-item').on('click', function() {
        $(this).closest('.order-item').remove();
    });


    // Random name attr for input for delete autocomplete
    var ID = function () {
        return '_' + Math.random().toString(36).substr(2, 9);
    };

    $('[name="n_p_city_id"]').siblings('.form-group').find('input').attr('name', ID);
    $('[name="n_p_warehouse_id"]').siblings('.form-group').find('input').attr('name', ID);


    //Dotdotdot
    $(".dotdotdot").dotdotdot({
        height: 32,
        watch: 'window'
    });


    /**
     * Open contact form if location has #call-back
     */
    if(window.location.hash && window.location.hash === '#call-back') {
        $(document).trigger('trigger.show.popup', ['callback']);
    }

    /**
     * Show\Hide top scroll
     */
    const heightWindow = $(window).height();
    let $btnToTop = $('#anchor_top_wrap'),
        $btnToTopMob = $('#modile-utilities-wrap'),
        statusShow = 0;

    $(document).scroll(function () {
        let $el = ($(window).width() >= 992) ? $btnToTop : $btnToTopMob;
        if($(this).scrollTop() >= heightWindow && statusShow === 0) {
            $el.fadeIn(200, function () {
                statusShow = 1;
            });
        } else if($(this).scrollTop() < heightWindow && statusShow === 1) {
            $el.fadeOut(200, function () {
                statusShow = 0;
            });
        }
    })

  /**
   * Short SEO
   */
//   let $seoContents = $('.main-about-wrap');
//   function seoContentShort(){
//     $seoContents.each(function () {
//         let $thisSeo = $(this).find('.main-about-text-wrap');
//         $thisSeo.removeAttr('style');
//         if($thisSeo.height() > 200) {
//             $thisSeo.attr('data-to-h', $thisSeo.height());
//             $thisSeo.css('height', 200);
//         } else {
//             $thisSeo.siblings('.main-about-more').remove();
//         }
//     });
//   };
//   seoContentShort();
//   $seoContents.find('.main-about-more a').on('click', function (e) {
//       e.preventDefault();
//       $(this).toggleClass('active');
//       $(this).parent().toggleClass('hide-bg');

//       let $sowersBlock = $(this).parent().siblings('.main-about-text-wrap');
//       if($(this).hasClass('active')) {
//           $sowersBlock.animate({
//               'height': $sowersBlock.attr('data-to-h') + 'px'
//           }, 200);
//       } else {
//           $sowersBlock.animate({
//               'height': '200px'
//           }, 200);
//       }
//   });
//   $(window).on('resize', function(){
//       seoContentShort();
//   });


  if($('#main-blog-page').length){
    var sidebar = new StickySidebar('.blog-sidebar', {
        containerSelector: '#main-blog-page',
        innerWrapperSelector: '.blog-sidebar-inner',
        topSpacing: 20,
        bottomSpacing: 40,
        resizeSensor: true,
    })
  }

    /**
     * Check cart available
     */
    $(document).on('click', 'a.to-checkout', function (e) {
        e.preventDefault();
        var url = $(this).attr('href'),
            $this = $(this);
        new CartActions().checkAvailableProducts(function (res) {
            if(res.data.html) {
                $('#available-warn .modal-body').html(res.data.html);
                $(document).trigger('trigger.show.popup', ['available-warn']);

                // Hide before open popup
                if($this.closest('#cartModal').length) {
                    $this.closest('#cartModal').addClass('hide-for-next-popup');
                    $('#available-warn').addClass('close-only-this show-cart-then');
                }
            } else {
                window.location.href = url;
            }
        });
    });

    $(".big_menu a[href*='#']").bind("click", function(e){
        if($(this).attr('href').includes('#reviews') && $('#reviews').length){
            e.preventDefault();
            var anchor = $(this);
            $('html, body').stop().animate({scrollTop: $('#reviews').offset().top }, 1000);
        }
    });

    jQuery.cookie = function(name, value, options) {
        if (typeof value != 'undefined') { // name and value given, set cookie
            options = options || {};
            if (value === null) {
                value = '';
                options.expires = -1;
            }
            var expires = '';
            if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
                var date;
                if (typeof options.expires == 'number') {
                    date = new Date();
                    date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
                } else {
                    date = options.expires;
                }
                expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
            }
            // CAUTION: Needed to parenthesize options.path and options.domain
            // in the following expressions, otherwise they evaluate to undefined
            // in the packed version for some reason...
            var path = options.path ? '; path=' + (options.path) : '';
            var domain = options.domain ? '; domain=' + (options.domain) : '';
            var secure = options.secure ? '; secure' : '';
            document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
        } else { // only name given, get cookie
            var cookieValue = null;
            if (document.cookie && document.cookie != '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = jQuery.trim(cookies[i]);
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) == (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }
    };
    if ($.cookie('acceptCookie') == null && $.cookie('rejectCookie') == null && $.cookie('cookiesSettings') == null) {
        $('.cookie-info').fadeIn(300);
    }
    $(document).on('click', '.cookie-accept-js', function (e) {
        e.preventDefault();
        $('.cookie-info').fadeOut(300);
        $.cookie('acceptCookie', 'active', { expires: 365000, path: '/' });
    });
    $(document).on('click', '.cookie-reject-js', function (e) {
        e.preventDefault();
        $('.cookie-info').fadeOut(300);
        $.cookie('rejectCookie', 'active', { expires: 365000, path: '/' });

        // default values
        let disabledCookies = ['set_cookie_2'];
        $.cookie('cookiesSettings', JSON.stringify(disabledCookies), { expires: 365000, path: '/' });
        location.reload();
    });

    $(document).on('click', '#cookies-setting-popup', function (e) {
        e.preventDefault();
        $('.cookie-info').fadeIn(300);
    });

    $(document).on('click', '#sb-settings-cookie-form', function (e) {
        e.preventDefault();

        let disabledCookies = [];
        let $settings = $('#settings-cookie-form input[type="checkbox"]:not(:checked)');
        $settings.each(function () {
            disabledCookies.push($(this).attr('name'));
        });
        $.cookie('cookiesSettings', JSON.stringify(disabledCookies), { expires: 365000, path: '/' });
        location.reload();
    });

    $(document).on('click', '.cookie-toogle-js', function (e) {
        e.preventDefault();
        $(this).siblings('.wysiwyg-base-style').slideToggle();
        $(this).toggleClass('closed');
    });

    $("#signIn-form").on('submit', function(e) {

        e.preventDefault();

        let form = $(this);

        if (form.valid(form,)) {

            let req = $.ajax({
                method: 'post',
                url: $(form).attr('action'),
                data: $(form).serialize()
            });

            req.done(function (resp) {

                if (resp.success) {
                    $('#signIn').fadeOut(200);
                    timerPopupMain('#signInSms');
                    $('#signInSms').fadeIn(200);
                } else {
                    bindErrors(form,resp);
                }

            });

        }

    });


    $("#signInSms-form").on('submit', function(e) {

        e.preventDefault();

        let form = $(this);

        if (form.valid()) {

            let req = $.ajax({
                method: 'post',
                url: $(form).attr('action'),
                data: $(form).serialize()
            });

            req.done(function (resp) {

                if (resp.success) {
                    window.location.reload();
                } else {
                    bindErrors(form,resp);
                }

            });

        }

    });


    $("#phoneChange-form").on('submit', function(e) {

        e.preventDefault();

        let form = $(this);

        if (form.valid()) {

            let req = $.ajax({
                method: 'post',
                url: $(form).attr('action'),
                data: $(form).serialize()
            });

            req.done(function (resp) {

                if (resp.success) {
                    $('#phoneChange').fadeOut(200);
                    timerPopupMain('#phoneChangeSms');
                    $('#phoneChangeSms').fadeIn(200);
                } else {
                    bindErrors(form,resp);
                }

            });
        }
    });


    $("#phoneChangeSms-form").on('submit', function(e) {

        e.preventDefault();

        let form = $(this);

        if (form.valid()) {

            let req = $.ajax({
                method: 'post',
                url: $(form).attr('action'),
                data: $(form).serialize()
            });

            req.done(function (resp) {

                if (resp.success) {
                    $('#account_phone').val($('#phoneChangeNew').val());
                    form.closest('.wrap_popup').find('.close').trigger('click');
                } else {
                    bindErrors(form,resp);
                }

            });








        }

    });


    let intrvlPopup = 0;
    function timerPopupMain(data) {
        $(data).find('.sms-block__again').hide(0);
        $(data).find('.sms-block__desc').show(0);
        let spanTime = $(data).find('.sms-block__desc span[data-time]');
        let time = Number(spanTime.data('time'));
        time = time - 1;
        intrvlPopup = setInterval(function() {
            if (time <= 0) {
                clearInterval(intrvlPopup);
                $(data).find('.sms-block__desc').hide();
                $(data).find('.sms-block__again').show();
                spanTime.text(time);
                time = Number(spanTime.data('time'));
            }
            spanTime.text(time--)
        }, 1000)
    }

    function clearTimerPopup() {
        console.log('clearTimerPopup');
        clearInterval(intrvlPopup);
        $('.sms-block__desc span').text(60);
    }

    $(document).on('click', '.sms-block__again', function (e) {
        e.preventDefault();
        var id = $(this).closest("form").attr('id');
        timerPopupMain("#" + id);
    });


    $("#accountRegister-form").on('submit', function(e) {

        e.preventDefault();

        let form = $(this);

        let step = $('#accountRegister');
        let step_next = $('#registerSms');
        let phone = form.find("input[type='tel']").val();

        if (form.valid()) {

            let req = $.ajax({
                method: 'post',
                url: $(form).attr('action'),
                data: $(form).serialize()
            });

            req.done(function (resp) {

                if (resp.success) {
                    $(step).fadeOut(200);
                    $(step_next).find(".phone_number").text(phone);
                    $(step_next).fadeIn(200);
                    timerPopupMain("#registerSms");
                } else {
                    bindErrors(form,resp);
                }

            });

        }

    });


    $("#registerSms-form").on('submit', function(e) {

        e.preventDefault();

        let form = $(this);

        if (form.valid()) {
            let req = $.ajax({
                method: 'post',
                url: $(form).attr('action'),
                data: $(form).serialize()
            });

            req.done(function (resp) {

                if (resp.success) {
                    window.location.reload();
                } else {
                    bindErrors(form,resp);
                }

            });
        }

    })


    function bindErrors(form, resp) {

        if (typeof resp.errors != 'undefined') { // array error bind

            $.each(resp.errors, function (name, value) {

                let field = $(form).find('[name=' + name + ']');
                field.addClass('error');

                if (field.siblings('.error').length) {
                    field.siblings('.error').text(value);
                    field.siblings('.error').show();
                } else {
                    field.after('<label id="' + name + '-error" class="error" for="' + name + '">' + value + '</label>');
                }
            });

        }

        if (typeof resp.message != 'undefined'){ // general error message
            console.log(resp.message);
        }

        return true;

    }

    function accountSearch(){

        $('.suggest_region').parent().siblings('.drop_down-list').on('click', 'li:not(.active):not(.info)', function () {

            let $this = $(this);
            $('input[name="account_region"]').val($this.closest('.drop_down').find('.drop_down-list li.active').data('id'));

        });


        //Suggest NP for profile
        let timeOut = '';
        $('.suggest_city').keyup(function () {

            let $this = $(this);
            clearTimeout(timeOut);

            timeOut = setTimeout(function () {

                let type = $this.attr('data-suggest'),
                    formData = new FormData();

                formData.append('type', type);
                formData.append('phrase', $this.val());
                if($this.attr('data-city-id')) {
                    formData.append('city_id', $this.attr('data-city-id'));
                }

                $.ajax({
                    type: "POST",
                    url: suggestNPUrl,
                    processData: false,
                    contentType: false,
                    data: formData,
                    dataType: "json",
                })
                .then(function (resp) {
                    if(resp.success) {
                        $('.drop_down-list .mCustomScrollbar').mCustomScrollbar('destroy');
                        $this.closest('.drop_down').find('.drop_down-list ul').html(resp.data.html);
                        $(".drop_down-list ul").mCustomScrollbar({
                            axis:"y"
                        });
                    }
                });
            }, 500);

        });
    }
    accountSearch();


    let show_bubble;
    // show_bubble
    $(".product-card__tooltip").mouseenter(function(e) {
        if(window.innerWidth < 1200){
            return false;
        }
        let offset = $(this).offset(),
            $product_name = $(this).text(),
            $width_name = e.currentTarget.offsetWidth,
            $height_text = $(e.target).hasClass('product-card__tooltip') ?  $(e.target).children().outerHeight() : $(e.target).outerHeight(),
            $position = $(this)[0].getBoundingClientRect(),
            $positionLeft = (window.innerWidth - e.pageX) <= e.pageX ? true : false,
            $width = $positionLeft ? e.pageX - 30 : window.innerWidth - e.pageX - 30,
            $positionStart = {
                left: $positionLeft ? 'auto' : e.pageX + 'px',
                right: $positionLeft ? (window.innerWidth - e.pageX - 30) + 'px' : 'auto',
            }
        let $this = $(this);
        if($height_text > 48){
            $('body').append('<div id="product-card-tooltip" style="max-width: ' + ($width <= 480 ? $width : 480) +'px; left:' + $positionStart.left +'; right:' + $positionStart.right +'; top:' + ($position.y + 60) +'px;">' + $product_name + '</div>');
        }
    });
    $(".product-card__tooltip").mouseleave(function() {
        clearTimeout(show_bubble);
        if(document.getElementById('product-card-tooltip')){
            document.getElementById('product-card-tooltip').remove();
        }
    });

});

$(document).on('change', '.politic-input', function () {
    let changed = false;
    let arrElems = document.querySelectorAll('.politic-input');
    for (let el of arrElems) {
        if(el.value != el.dataset.start){
            changed = true;
            break
        }
    }
    if(changed){
        $('#politic-profile').removeClass('disabled');
    } else {
        $('#politic-profile').addClass('disabled');
        $('#politic-profile').prop('checked', true);
    }
});

